import { toast } from "react-toastify";

import * as algosdk from "algosdk"; // TEMPORARY
import confirmPeraOptInRequestV2 from "../../apis/prod/pera/confirm_optin_bid_contract";
// import confirmPeraOptInRequest from "../../apis/prod/pera/confirm_optin_contract";
import confirmPeraCloseOutRequest from "../../apis/prod/pera/confirm_closeout_contract";
import confirmPeraBulkCloseOutRequest from "../../apis/prod/pera/confirm_bulk_closeout_contract";
import confirmPeraBidRequest from "../../apis/prod/pera/confirm_bid_contract";

import confirmPeraCloseOutPortfolioRequest from "../../apis/prod/pera/confirm_closeout_portfolio_contract";
import confirmPeraOptInPortfolioRequest from "../../apis/prod/pera/confirm_optin_portfolio_contract";
import confirmPeraUpdatePortfolioRequest from "../../apis/prod/pera/confirm_update_portfolio_contract";

import encryptContract from "../../apis/prod/utils/encrypt_contract";
import encryptPortfolio from "../../apis/prod/utils/encrypt_portfolio";
import researchHash from "../../apis/prod/utils/research_hash";
import getCloseOutCids from "../../apis/prod/utils/get_close_out_cids";

import confirmWalletOwnership from "../../apis/prod/pera/confirm_wallet_ownership";

import ParcisionCookies from "~/utils/Cookies";
import { sentryWrappedException } from "~/utils/Utils";

type RequestType = [
  { txn: algosdk.Transaction; signers: string[] },
  { txn: algosdk.Transaction; signers: string[] },
  { txn: algosdk.Transaction; signers: string[] }
];
type PortfolioRequestType = [
  { txn: algosdk.Transaction; signers: string[] },
  { txn: algosdk.Transaction; signers: string[] }
];
async function apiGetTxnParams(): Promise<algosdk.SuggestedParams> {
  const testNetClient = new algosdk.Algodv2("", "https://testnet-api.algonode.cloud", "");
  return testNetClient.getTransactionParams().do();
}

async function getOptInRequest(
  cid: number,
  cidaddr: string,
  address: string,
  appArgs: Uint8Array[],
  inputAmountMicroAlgos: number | bigint
): Promise<RequestType> {
  try {
    // CHECK NONCE SO PEOPLE CAN ONLY MAKE REQUESTS FOR ADDRESS THEY CAN ACCESS
    // let sender = "Z6G7EALOIBYBTBPGXPE6533L5D65NBSZNT2MRQOUB7VNICN6JGL6SC2TWI"

    // VERIFY VIA WEB3 BY SIGNING A TRANSCATION WITH THIS ENCRYPTED NONCE
    const params = await apiGetTxnParams();

    const payment_note = new Uint8Array(Buffer.from("web3estimate"));

    // PREPARE OPT IN CONTRACT
    const txn_optin = algosdk.makeApplicationOptInTxn(address, params, cid);

    // PREPARE OPT IN CONTRACT
    const txn_app = algosdk.makeApplicationNoOpTxn(address, params, Number(cid), appArgs);
    const txn_pay = algosdk.makePaymentTxnWithSuggestedParams(
      address,
      cidaddr,
      inputAmountMicroAlgos,
      undefined,
      payment_note,
      params
    );

    const txns = algosdk.assignGroupID([txn_optin, txn_app, txn_pay]);

    // SEND BACK THE REQUEST FOR SIGNING
    return [
      { txn: txns[0], signers: [address] },
      { txn: txns[1], signers: [address] },
      { txn: txns[2], signers: [address] },
    ];
  } catch (err) {
    sentryWrappedException(err);
    toast.error("Failed to confirm opt-in request");
    throw err;
  }
}

async function getOptOutRequest(cid: number, address: string, prvwager: number, appArgs: Uint8Array[]) {
  try {
    // CHECK NONCE SO PEOPLE CAN ONLY MAKE REQUESTS FOR ADDRESS THEY CAN ACCESS
    // let sender = "Z6G7EALOIBYBTBPGXPE6533L5D65NBSZNT2MRQOUB7VNICN6JGL6SC2TWI"

    // VERIFY VIA WEB3 BY SIGNING A TRANSCATION WITH THIS ENCRYPTED NONCE
    const params = await apiGetTxnParams();

    // PREPARE OPT IN CONTRACT
    const app_options = {
      appArgs,
      appIndex: Number(cid),
      from: address,
      onComplete: algosdk.OnApplicationComplete.NoOpOC,
      suggestedParams: params,
    };
    const txn_withdraw = algosdk.makeApplicationCallTxnFromObject(app_options);

    // PREPARE OPT IN CONTRACT
    const txn_close = algosdk.makeApplicationCloseOutTxn(address, params, cid);

    let txns;
    if (prvwager > 0) {
      txns = algosdk.assignGroupID([txn_withdraw, txn_close]);
      // SEND BACK THE REQUEST FOR SIGNING
      return [
        { txn: txns[0], signers: [address] },
        { txn: txns[1], signers: [address] },
      ];
    }
    txns = algosdk.assignGroupID([txn_close]);

    // SEND BACK THE REQUEST FOR SIGNING
    return [{ txn: txns[0], signers: [address] }];
  } catch (err) {
    sentryWrappedException(err);
    toast.error("Failed to confirm close out request");
    throw err;
  }
}

export async function optInPera(
  cid: number,
  gparam: string,
  cidaddr: string,
  prvwager: number,
  estimate1: number,
  estimate2: number,
  estimate3: number,
  wager: number,
  description: string,
  // @ts-expect-error
  handleSignWalletTxn
) {
  const toastId = toast.info(`Submitting bid for ${gparam} with Pera wallet.`, { autoClose: false });

  const address = ParcisionCookies.get("address");

  const inputEstimate1 = estimate1; // CENTS
  const inputEstimate2 = estimate2; // DOLLARS
  const inputEstimate3 = estimate3; // PERCENTAGE

  // Send inputEstimateCents to AWS API to encrypt
  const inputAmountMicroAlgos = Math.floor(wager * 1000000); // INCLUDE 2X TXN FEES (ASSUMING THEY )

  // encrypt estimate & description
  const encrypted = await encryptContract(cid, inputEstimate1, inputEstimate2, inputEstimate3, description);
  const encrypted_estimate1 = encrypted.estimate1;
  const encrypted_estimate2 = encrypted.estimate2;
  const encrypted_estimate3 = encrypted.estimate3;
  const encrypted_description = encrypted.description;

  const research_sign = await researchHash(cid);

  const decision = `${encrypted_description}_${research_sign.research_sign}`;

  const uint8array_description = new Uint8Array(Buffer.from(decision));

  let inputAdjAmountMicroAlgos_ = 0;

  const appArgs = [];
  // submit first bid
  appArgs.push(new Uint8Array(Buffer.from("local_optin_bid")));
  appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate1)));
  appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate2)));
  appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate3)));
  appArgs.push(new Uint8Array(Buffer.from(algosdk.encodeUint64(inputAmountMicroAlgos))));
  appArgs.push(uint8array_description);

  // TODO: does this do something? - ch
  inputAdjAmountMicroAlgos_ = inputAmountMicroAlgos - 0;

  // CREATE A WEB3 REQUEST FOR SIGNING
  // const request = await getOptInRequest(cid, address);

  const request = await getOptInRequest(cid, cidaddr, address, appArgs, inputAdjAmountMicroAlgos_);

  // SIGN TXN
  let result;
  try {
    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Sign Bid transaction.</div>,
    });

    result = await handleSignWalletTxn(request);

    if (typeof result[0] !== "string") {
      // android
      const result_uint8array_1 = new Uint8Array(result[0]);
      const result_uint8array_2 = new Uint8Array(result[1]);
      const result_uint8array_3 = new Uint8Array(result[2]);
      result = [
        window.btoa(String.fromCharCode.apply(null, result_uint8array_1)),
        window.btoa(String.fromCharCode.apply(null, result_uint8array_2)),
        window.btoa(String.fromCharCode.apply(null, result_uint8array_3)),
      ];
    }

    // @ts-expect-error
    const decodedResult = result.map((element) => {
      return element || "";
    });

    // CONFIRM TRANSACTION
    let stage;
    if (wager > 0 && prvwager === 0) {
      stage = "BID";
    } else if (wager === 0 && prvwager > 0) {
      stage = "OPTIN";
    } else {
      stage = "UPDATE";
    }

    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Please hold while we confirm your submission on the blockchain.</div>,
    });

    // CONFIRM TRANSACTION
    const contract_data = await confirmPeraOptInRequestV2(
      decodedResult,
      cid,
      wager,
      estimate1,
      estimate2,
      estimate3,
      description,
      stage
    );

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return contract_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

// @ts-expect-error
export async function closeOutPera(cid: number, gparam: string, prvwager: number, handleSignWalletTxn) {
  const toastId = toast.info(`Closing out ${gparam} with Pera wallet.`, { autoClose: false });

  const address = ParcisionCookies.get("address");

  // const encrypted_description = "ABC"; // crypto.createHash("sha1").update(JSON.stringify(description)).digest("hex");
  const decision = `CLOSE OUT_NaN`;
  const uint8array_description = new Uint8Array(Buffer.from(decision));

  const appArgs = [];

  // submit and update
  appArgs.push(new Uint8Array(Buffer.from("local_withdraw_all_closeout_update")));
  appArgs.push(new Uint8Array(Buffer.from("0")));
  appArgs.push(new Uint8Array(Buffer.from("0")));
  appArgs.push(new Uint8Array(Buffer.from("0")));
  appArgs.push(new Uint8Array(Buffer.from(algosdk.encodeUint64(0))));
  appArgs.push(uint8array_description);

  // check if account opted in already
  // CREATE A WEB3 REQUEST FOR SIGNING
  const request = await getOptOutRequest(cid, address, prvwager, appArgs);

  // SIGN TRANSACTION
  let result;
  try {
    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Sign Close out transaction.</div>,
    });

    result = await handleSignWalletTxn(request);

    if (typeof result[0] !== "string") {
      if (result.length === 1) {
        // android
        const result_uint8array = new Uint8Array(result[0]);
        result = [window.btoa(String.fromCharCode.apply(null, result_uint8array))];
      } else if (result.length === 2) {
        // android
        const result_uint8array_1 = new Uint8Array(result[0]);
        const result_uint8array_2 = new Uint8Array(result[1]);
        result = [
          window.btoa(String.fromCharCode.apply(null, result_uint8array_1)),
          window.btoa(String.fromCharCode.apply(null, result_uint8array_2)),
        ];
      }
    }

    // @ts-expect-error
    const decodedResult = result.map((element) => {
      return element || "";
    });

    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Please hold while we confirm your submission on the blockchain.</div>,
    });

    // CONFIRM THE TRANSACTION
    const contract_data = await confirmPeraCloseOutRequest(decodedResult, cid);

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return contract_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

async function getBidIncRequest(
  cid: number,
  cidaddr: string,
  address: string,
  appArgs: Uint8Array[],
  inputAmountMicroAlgos: number | bigint
) {
  try {
    // CHECK NONCE SO PEOPLE CAN ONLY MAKE REQUESTS FOR ADDRESS THEY CAN ACCESS
    // let sender = "Z6G7EALOIBYBTBPGXPE6533L5D65NBSZNT2MRQOUB7VNICN6JGL6SC2TWI"

    const payment_note = new Uint8Array(Buffer.from("web3estimate"));

    // VERIFY VIA WEB3 BY SIGNING A TRANSCATION WITH THIS ENCRYPTED NONCE
    const params = await apiGetTxnParams();

    // PREPARE OPT IN CONTRACT
    const app_txn = algosdk.makeApplicationNoOpTxn(address, params, Number(cid), appArgs);
    const pay_txn = algosdk.makePaymentTxnWithSuggestedParams(
      address,
      cidaddr,
      inputAmountMicroAlgos,
      undefined,
      payment_note,
      params
    );
    // const txn = algosdk.assignGroupID([app_txn, pay_txn]);

    const txns = algosdk.assignGroupID([app_txn, pay_txn]);

    // SEND BACK THE REQUEST FOR SIGNING
    return [
      { txn: txns[0], signers: [address] },
      { txn: txns[1], signers: [address] },
    ];
    // return [{txn, signers: [address]}];
  } catch (err) {
    sentryWrappedException(err);
    toast.error("Failed to complete bid request");
    throw err;
  }
}

async function getBidDecRequest(cid: number, address: string, appArgs: Uint8Array[]) {
  try {
    // CHECK NONCE SO PEOPLE CAN ONLY MAKE REQUESTS FOR ADDRESS THEY CAN ACCESS
    // let sender = "Z6G7EALOIBYBTBPGXPE6533L5D65NBSZNT2MRQOUB7VNICN6JGL6SC2TWI"

    // let payment_note = new Uint8Array(Buffer.from("web3estimate"));

    // VERIFY VIA WEB3 BY SIGNING A TRANSCATION WITH THIS ENCRYPTED NONCE
    const params = await apiGetTxnParams();

    // PREPARE OPT IN CONTRACT
    const app_options = {
      appArgs,
      appIndex: Number(cid),
      from: address,
      onComplete: algosdk.OnApplicationComplete.NoOpOC,
      suggestedParams: params,
    };
    const dec_txn = algosdk.makeApplicationCallTxnFromObject(app_options);
    const txns = algosdk.assignGroupID([dec_txn]);

    // SEND BACK THE REQUEST FOR SIGNING
    return [{ txn: txns[0], signers: [address] }];
  } catch (err) {
    sentryWrappedException(err);
    toast.error("Failed to confirm bid request");
    throw err;
  }
}

export async function submitBidPera(
  cid: number,
  gparam: string,
  cidaddr: string,
  // @ts-expect-error
  handleSignWalletTxn,
  prvwager: number,
  estimate1: number,
  estimate2: number,
  estimate3: number,
  wager: number,
  description: string
) {
  const toastId = toast.info(`Submit ${gparam} bid with Pera wallet.`, { autoClose: false });

  const address = ParcisionCookies.get("address");

  const appArgs = [];

  const inputEstimate1 = estimate1; // CENTS
  const inputEstimate2 = estimate2; // DOLLARS
  const inputEstimate3 = estimate3; // PERCENTAGE

  // Send inputEstimateCents to AWS API to encrypt
  const inputAmountMicroAlgos = Math.floor(wager * 1000000); // INCLUDE 2X TXN FEES (ASSUMING THEY )
  const prvAmountMicroAlgos = Math.floor(prvwager * 1000000); // INCLUDE 2X TXN FEES (ASSUMING THEY )

  // encrypt estimate & description
  const encrypted = await encryptContract(cid, inputEstimate1, inputEstimate2, inputEstimate3, description);
  const encrypted_estimate1 = encrypted.estimate1;
  const encrypted_estimate2 = encrypted.estimate2;
  const encrypted_estimate3 = encrypted.estimate3;
  const encrypted_description = encrypted.description;

  const research_sign = await researchHash(cid);
  // const encrypted_description = encrypted.description;

  // LETS ENCRYPT:  51VIkucrn/CnmYvGNalzizkllzQRvBQENYo0gdJBlACMHnB7ttIDan38jlKfdqOS
  // ContractDetails.js:253

  // const encrypted_description = "ABC"; // crypto.createHash("sha1").update(JSON.stringify(description)).digest("hex");
  const decision = `${encrypted_description}_${research_sign.research_sign}`;

  const uint8array_description = new Uint8Array(Buffer.from(decision));

  let inputAdjAmountMicroAlgos_ = 0;
  // local_decision takes up 14 entries = 128 - 14 = 114
  // let uint8array_description_0_114;
  // let uint8array_description_129_N;
  // WE CAN DO EVENS, ODDS, OR SKIP N UNTIL LENGTH <= 128
  // if (uint8array_description.length > 114) {
  //  uint8array_description_0_114 = uint8array_description.slice(0, 114);
  // uint8array_description_129_N = uint8array_description.slice(114);
  // } else {
  //  uint8array_description_0_114 = uint8array_description;
  // uint8array_description_129_N = []
  // }

  if (prvwager === 0) {
    if (wager > 0) {
      // submit first bid
      appArgs.push(new Uint8Array(Buffer.from("local_bid")));
      appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate1)));
      appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate2)));
      appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate3)));
      appArgs.push(new Uint8Array(Buffer.from(algosdk.encodeUint64(inputAmountMicroAlgos))));
      appArgs.push(uint8array_description);

      // TODO: does this do something? - ch
      inputAdjAmountMicroAlgos_ = inputAmountMicroAlgos - 0;
    } else {
      // WTF
    }
  } else if (wager > prvwager) {
    // submit and update
    appArgs.push(new Uint8Array(Buffer.from("local_deposit_update")));
    appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate1)));
    appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate2)));
    appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate3)));
    appArgs.push(new Uint8Array(Buffer.from(algosdk.encodeUint64(inputAmountMicroAlgos))));
    appArgs.push(uint8array_description);

    inputAdjAmountMicroAlgos_ = inputAmountMicroAlgos - prvAmountMicroAlgos;

    // we are going to check that the first transfer matches this
    appArgs.push(new Uint8Array(Buffer.from(algosdk.encodeUint64(inputAdjAmountMicroAlgos_))));
  } else if (wager < prvwager) {
    if (wager === 0) {
      // submit and update
      appArgs.push(new Uint8Array(Buffer.from("local_withdraw_all_update")));
      appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate1)));
      appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate2)));
      appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate3)));
      appArgs.push(new Uint8Array(Buffer.from(algosdk.encodeUint64(inputAmountMicroAlgos))));
      appArgs.push(uint8array_description);

      inputAdjAmountMicroAlgos_ = inputAmountMicroAlgos - prvAmountMicroAlgos;
    } else {
      // submit and update
      appArgs.push(new Uint8Array(Buffer.from("local_withdraw_update")));
      appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate1)));
      appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate2)));
      appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate3)));
      appArgs.push(new Uint8Array(Buffer.from(algosdk.encodeUint64(inputAmountMicroAlgos))));
      appArgs.push(uint8array_description);

      inputAdjAmountMicroAlgos_ = inputAmountMicroAlgos - prvAmountMicroAlgos;
    }
  } else {
    // submit and update
    appArgs.push(new Uint8Array(Buffer.from("local_nochange_update")));
    appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate1)));
    appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate2)));
    appArgs.push(new Uint8Array(Buffer.from(encrypted_estimate3)));
    // appArgs.push(new Uint8Array(Buffer.from(algosdk.encodeUint64(inputBidMicroAlgos))));
    appArgs.push(uint8array_description);

    inputAdjAmountMicroAlgos_ = 0; // inputBidMicroAlgos - currentLocalBidAmount
  }

  let request;

  if (inputAdjAmountMicroAlgos_ > 0) {
    // BID OR INCREASE AMOUNT
    request = await getBidIncRequest(cid, cidaddr, address, appArgs, inputAdjAmountMicroAlgos_);
  } else {
    // DESCREASE OR WITHDRAW AMOUNT
    request = await getBidDecRequest(cid, address, appArgs);
  }

  // SIGN TXN
  let result;
  try {
    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Sign Bid transaction.</div>,
    });

    result = await handleSignWalletTxn(request);

    if (typeof result[0] !== "string") {
      if (result.length === 1) {
        // android
        const result_uint8array = new Uint8Array(result[0]);
        result = [window.btoa(String.fromCharCode.apply(null, result_uint8array))];
      } else if (result.length === 2) {
        // android
        const result_uint8array_1 = new Uint8Array(result[0]);
        const result_uint8array_2 = new Uint8Array(result[1]);
        result = [
          window.btoa(String.fromCharCode.apply(null, result_uint8array_1)),
          window.btoa(String.fromCharCode.apply(null, result_uint8array_2)),
        ];
      }
    }

    // @ts-expect-error
    const decodedResult = result.map((element) => {
      return element || "";
    });

    // CONFIRM TRANSACTION
    let stage;
    if (wager > 0 && prvwager === 0) {
      stage = "BID";
    } else if (wager === 0 && prvwager > 0) {
      stage = "OPTIN";
    } else {
      stage = "UPDATE";
    }

    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Please hold while we confirm your submission on the blockchain.</div>,
    });

    // CONFIRM TRANSACTION
    const contract_data = await confirmPeraBidRequest(
      decodedResult,
      cid,
      wager,
      estimate1,
      estimate2,
      estimate3,
      description,
      stage
    );

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return contract_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

// @ts-expect-error
export async function bulkCloseOutPera(handleSignWalletTxn) {
  const contracts = await getCloseOutCids();
  const cids = contracts.contracts.map((a: { cid: number }) => a.cid);

  const toastId = toast.info(`Closing out BULK with Pera wallet.`, { autoClose: false });

  const address = ParcisionCookies.get("address");

  // check if account opted in already
  // CREATE A WEB3 REQUEST FOR SIGNING

  // VERIFY VIA WEB3 BY SIGNING A TRANSCATION WITH THIS ENCRYPTED NONCE
  const params = await apiGetTxnParams();

  // PREPARE OPT IN CONTRACT
  const txn_ = [];
  for (let i = 0; i < cids.length; i++) {
    const txn_tmp = algosdk.makeApplicationCloseOutTxn(address, params, cids[i]);
    txn_.push(txn_tmp);
  }

  const txns = algosdk.assignGroupID(txn_);

  // SEND BACK THE REQUEST FOR SIGNING
  const request = [];
  for (let i = 0; i < cids.length; i++) {
    request.push({ txn: txns[i], signers: [address] });
  }

  // SIGN TRANSACTION
  let result;
  try {
    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Sign Close out transaction.</div>,
    });

    result = await handleSignWalletTxn(request);

    if (typeof result[0] !== "string") {
      // android
      const result_tmp = [];
      for (let i = 0; i < cids.length; i++) {
        const result_uint8array = new Uint8Array(result[i]);
        const tmp = window.btoa(String.fromCharCode.apply(null, result_uint8array));
        result_tmp.push(tmp);
      }
      result = result_tmp;
    }

    // @ts-expect-error
    const decodedResult3 = result.map((element) => {
      return element || null;
    });

    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Please hold while we confirm your submission on the blockchain.</div>,
    });

    // CONFIRM THE TRANSACTION
    const contract_data = await confirmPeraBulkCloseOutRequest(decodedResult3, cids);

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return message;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

/// ////////////
// PORTFOLIO //
/// ////////////

async function getOptInPortfolioRequest(
  pid: number,
  address: string,
  appArgs: Uint8Array[]
): Promise<PortfolioRequestType> {
  try {
    // CHECK NONCE SO PEOPLE CAN ONLY MAKE REQUESTS FOR ADDRESS THEY CAN ACCESS
    // let sender = "Z6G7EALOIBYBTBPGXPE6533L5D65NBSZNT2MRQOUB7VNICN6JGL6SC2TWI"

    // VERIFY VIA WEB3 BY SIGNING A TRANSCATION WITH THIS ENCRYPTED NONCE
    const params = await apiGetTxnParams();

    // PREPARE OPT IN CONTRACT
    const txn_optin = algosdk.makeApplicationOptInTxn(address, params, pid);

    // PREPARE OPT IN CONTRACT
    const txn_app = algosdk.makeApplicationNoOpTxn(address, params, pid, appArgs);

    const txns = algosdk.assignGroupID([txn_optin, txn_app]);

    // SEND BACK THE REQUEST FOR SIGNING
    return [
      { txn: txns[0], signers: [address] },
      { txn: txns[1], signers: [address] },
    ];
  } catch (err) {
    sentryWrappedException(err);
    toast.error("Failed to confirm opt-in request");
    throw err;
  }
}

async function getOptOutPortfolioRequest(pid: number, address: string) {
  try {
    // CHECK NONCE SO PEOPLE CAN ONLY MAKE REQUESTS FOR ADDRESS THEY CAN ACCESS
    // let sender = "Z6G7EALOIBYBTBPGXPE6533L5D65NBSZNT2MRQOUB7VNICN6JGL6SC2TWI"

    // VERIFY VIA WEB3 BY SIGNING A TRANSCATION WITH THIS ENCRYPTED NONCE
    const params = await apiGetTxnParams();

    // PREPARE OPT IN CONTRACT
    const txn_close = algosdk.makeApplicationCloseOutTxn(address, params, pid);

    const txns = algosdk.assignGroupID([txn_close]);

    // SEND BACK THE REQUEST FOR SIGNING
    return [{ txn: txns[0], signers: [address] }];
  } catch (err) {
    sentryWrappedException(err);
    toast.error("Failed to confirm close out request");
    throw err;
  }
}

export async function optInPortfolioPera(
  pid: number,
  phash: string,
  pverified: boolean,
  rhash: string,
  rverified: boolean,
  description: string,
  // @ts-expect-error
  handleSignWalletTxn
) {
  const toastId = toast.info(`Submitting update for portfolio with Pera wallet.`, { autoClose: false });

  const address = ParcisionCookies.get("address");

  // encrypt estimate & description
  const encrypted = await encryptPortfolio(pid, phash, rhash, description);
  const encrypted_phash = encrypted.phash;
  const encrypted_rhash = encrypted.rhash;
  const encrypted_description = encrypted.description;

  const uint8array_description = new Uint8Array(Buffer.from(encrypted_description));

  const appArgs = [];
  // submit first bid
  appArgs.push(new Uint8Array(Buffer.from("local_update")));
  appArgs.push(new Uint8Array(Buffer.from(encrypted_phash)));
  appArgs.push(new Uint8Array(Buffer.from(encrypted_rhash)));
  appArgs.push(uint8array_description);

  // CREATE A WEB3 REQUEST FOR SIGNING
  // const request = await getOptInRequest(cid, address);

  const request = await getOptInPortfolioRequest(pid, address, appArgs);

  // SIGN TXN
  let result;
  try {
    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Sign Bid transaction.</div>,
    });

    result = await handleSignWalletTxn(request);

    if (typeof result[0] !== "string") {
      // android
      const result_uint8array_1 = new Uint8Array(result[0]);
      const result_uint8array_2 = new Uint8Array(result[1]);
      result = [
        window.btoa(String.fromCharCode.apply(null, result_uint8array_1)),
        window.btoa(String.fromCharCode.apply(null, result_uint8array_2)),
      ];
    }

    // @ts-expect-error
    const decodedResult = result.map((element) => {
      return element || "";
    });

    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Please hold while we confirm your submission on the blockchain.</div>,
    });

    // CONFIRM TRANSACTION
    const contract_data = await confirmPeraOptInPortfolioRequest(
      decodedResult,
      pid,
      phash,
      pverified,
      rhash,
      rverified,
      description
    );

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return contract_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

// @ts-expect-error
export async function closeOutPortfolioPera(pid: number, handleSignWalletTxn) {
  const toastId = toast.info(`Closing out portfolio with Pera wallet.`, { autoClose: false });

  const address = ParcisionCookies.get("address");

  // check if account opted in already
  // CREATE A WEB3 REQUEST FOR SIGNING
  const request = await getOptOutPortfolioRequest(pid, address);

  // SIGN TRANSACTION
  let result;
  try {
    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Sign Close out transaction.</div>,
    });

    result = await handleSignWalletTxn(request);

    if (typeof result[0] !== "string") {
      // android
      const result_uint8array = new Uint8Array(result[0]);
      result = [window.btoa(String.fromCharCode.apply(null, result_uint8array))];
    }

    // @ts-expect-error
    const decodedResult = result.map((element) => {
      return element || "";
    });

    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Please hold while we confirm your submission on the blockchain.</div>,
    });

    // CONFIRM THE TRANSACTION
    const contract_data = await confirmPeraCloseOutPortfolioRequest(decodedResult, pid);

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return contract_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

async function updatePortfolioPeraRequest(pid: number, address: string, appArgs: Uint8Array[]) {
  try {
    // CHECK NONCE SO PEOPLE CAN ONLY MAKE REQUESTS FOR ADDRESS THEY CAN ACCESS
    // let sender = "Z6G7EALOIBYBTBPGXPE6533L5D65NBSZNT2MRQOUB7VNICN6JGL6SC2TWI"

    // VERIFY VIA WEB3 BY SIGNING A TRANSCATION WITH THIS ENCRYPTED NONCE
    const params = await apiGetTxnParams();

    // PREPARE OPT IN CONTRACT
    const app_txn = algosdk.makeApplicationNoOpTxn(address, params, pid, appArgs);
    // const txn = algosdk.assignGroupID([app_txn, pay_txn]);

    const txns = algosdk.assignGroupID([app_txn]);

    // SEND BACK THE REQUEST FOR SIGNING
    return [{ txn: txns[0], signers: [address] }];
    // return [{txn, signers: [address]}];
  } catch (err) {
    sentryWrappedException(err);
    toast.error("Failed to complete bid request");
    throw err;
  }
}

export async function updatePortfolioPera(
  pid: number,
  phash: string,
  pverified: boolean,
  rhash: string,
  rverified: boolean,
  description: string,
  // @ts-expect-error
  handleSignWalletTxn
) {
  const toastId = toast.info(`Submitting update for portfolio with Pera wallet.`, { autoClose: false });

  const address = ParcisionCookies.get("address");

  // encrypt estimate & description
  const encrypted = await encryptPortfolio(pid, phash, rhash, description);
  const encrypted_phash = encrypted.phash;
  const encrypted_rhash = encrypted.rhash;
  const encrypted_description = encrypted.description;

  const uint8array_description = new Uint8Array(Buffer.from(encrypted_description));

  const appArgs = [];
  // submit first bid
  appArgs.push(new Uint8Array(Buffer.from("local_update")));
  appArgs.push(new Uint8Array(Buffer.from(encrypted_phash)));
  appArgs.push(new Uint8Array(Buffer.from(encrypted_rhash)));
  appArgs.push(uint8array_description);

  // CREATE A WEB3 REQUEST FOR SIGNING
  // const request = await getOptInRequest(cid, address);

  const request = await updatePortfolioPeraRequest(pid, address, appArgs);

  // SIGN TXN
  let result;
  try {
    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Sign Bid transaction.</div>,
    });

    result = await handleSignWalletTxn(request);

    if (typeof result[0] !== "string") {
      // android
      const result_uint8array_1 = new Uint8Array(result[0]);
      result = [window.btoa(String.fromCharCode.apply(null, result_uint8array_1))];
    }

    // @ts-expect-error
    const decodedResult = result.map((element) => {
      return element || "";
    });

    toast.update(toastId, {
      type: toast.TYPE.INFO,
      autoClose: false,
      render: () => <div>Please hold while we confirm your submission on the blockchain.</div>,
    });

    // CONFIRM TRANSACTION
    const contract_data = await confirmPeraUpdatePortfolioRequest(
      decodedResult,
      pid,
      phash,
      pverified,
      rhash,
      rverified,
      description
    );

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return contract_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

export async function confirmPeraWalletOwnership() {
  const message = await confirmWalletOwnership();

  if (message.toLowerCase().indexOf("verify wallet ownership") >= 0) {
    return "Verify Pera Wallet";
  }
  return "";
}
